export const timeGrainOptions = [
  {
    id: 'day',
    name: 'Day',
  },
  {
    id: 'week',
    name: 'Week',
  },
  {
    id: 'month',
    name: 'Month',
  },
  {
    id: 'quarter',
    name: 'Quarter',
  },
  {
    id: 'year',
    name: 'Year',
  },
];
